import { Brands } from '@core-ui/react-stitch';
import { NavLinks } from '../../static-page-data/nav-links';

type AppendNavTrackingParamsResponse = NavLinks[Brands] | [];

const appendNavTrackingParams = (
  navLinks: NavLinks[Brands],
  theme: string
): AppendNavTrackingParamsResponse => {
  const navTrackingParam = `nav=expmore:CLPDivision:CLPCategory:${theme}`;

  if (!navLinks) {
    return [];
  }

  return navLinks.map((navLink) => {
    const paramDelimiter = navLink.link.includes('?') ? '&' : '?';

    return {
      name: navLink.name,
      link: `${navLink.link}${paramDelimiter}${navTrackingParam}`
    };
  });
};

export default appendNavTrackingParams;
